import { BaseService } from '@services/BaseService';
import { PageViewModel } from '@models/common.models';
import { QuoteViewModel, QuoteSearchViewModel } from '@models/Quote';
import { ContractViewModel } from '@models/Contract';

class QuoteService extends BaseService {
  constructor() {
    super('quotes');
  }

  searchQuotes(
    query: string | null,
    pageSize?: number,
    page?: number,
    orderBy?: string,
    orderDirection?: string,
    filterByConverted?: boolean
  ) {
    if (!filterByConverted) {
      filterByConverted = undefined;
    }

    return this.fetch<PageViewModel<QuoteSearchViewModel>>('search', {
      method: 'POST',
      body: JSON.stringify({
        query: query,
        pageSize: pageSize,
        pageNumber: page,
        orderBy: orderBy,
        orderDirection: orderDirection,
        filterBy: filterByConverted
      })
    });
  }

  saveQuote(model: ContractViewModel) {
    return this.fetch<number>('', {
      method: 'POST',
      body: JSON.stringify(model)
    });
  }

  getQuote(id: number): Promise<QuoteViewModel> {
    return this.fetch<QuoteViewModel>(`${id}`, {
      method: 'GET'
    });
  }
  emailQuote(id: number, email: string) {
    return this.fetch(`${id}/email?email=${email}`, {
      method: 'POST'
    });
  }
}

export const quoteService = new QuoteService();



// WEBPACK FOOTER //
// ./src/_services/QuoteService.ts